var map = {
	"./pr-1.png": "f38a",
	"./pr-2.png": "d1ca",
	"./pr-3.png": "8f49",
	"./pr-4.png": "8587",
	"./pr-5.png": "323a",
	"./pr-5_.png": "819a",
	"./pr-6.png": "1e28",
	"./pr-7.png": "8941",
	"./pr-8.png": "eabd",
	"./pr-9.png": "95fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e00";